import Model from './Model';
import ModalWindow from './ModalWindow';
// import { minToHoursMin } from './Helpers';
import 'slick-carousel';
import { minToHoursMin } from './Helpers';

let RenderPageData = function(baseElem) {
  // console.log('Model:', JSON.stringify(Model, null, '\t'));
  let katIdArray = [];
  let sortableArray = [];
  if (Object.keys(Model.data).length > 0) {
    $('#pageTitle').text(Model.projektInfo.titel);
    console.log('Model.data:', Model.data);
    // console.log('Model.data:', JSON.stringify(Model.data, null, '\t'));

    $.each(Model.data, function(key, val) {
      // console.log('%ckey:' + key, 'color:orange;');
      // console.log('val:', JSON.stringify(val, null, '\t'));
      sortableArray.push(val);
    });

    sortableArray.sort(function(a, b) {
      // return a.kat_id - b.kat_id || a.kTitel.localeCompare(b.kTitel);
      return (
        a.kursus_sortorder - b.kursus_sortorder ||
        a.kTitel.localeCompare(b.kTitel)
      );
      // return a.kursus_sortorder - b.kursus_sortorder || a.kId - b.kId;
    });
    $.each(sortableArray, function(key2, val2) {
      console.log('key:' + key2 + ' val:' + JSON.stringify(val2, null, '\t'));
      let thisKatId = val2.kat_id;

      if (katIdArray.indexOf(thisKatId) === -1) {
        // console.log('thisKatId:', thisKatId);
        let kategoriContainer = $('<div>', {
          id: 'kategoriContainer' + thisKatId,
          'data-katId': thisKatId,
          class: 'kategoriContainer',
        }).appendTo(baseElem);
        $('<h4>', {
          class: 'kategoriHeader',
          html: val2.kursus_kategori,
        }).appendTo(kategoriContainer);

        let kategoriBody = $('<div>', {
          class: 'kategoriBody',
          html: val2.kategoriHeader,
        }).appendTo(kategoriContainer);

        $('<div>', {
          class: 'carouselWrapper slider',
          id: 'carouselWrapper_' + thisKatId,
          // 'data-ride':'carousel'
          // html: val.kursus_kategori
        }).appendTo(kategoriBody);
        katIdArray.push(thisKatId);
      }
      let cItem = $('<div>', {
        id: 'cItem_' + val2.kId,
        class: 'carousel-item',
      }).appendTo($('#carouselWrapper_' + thisKatId));

      $('<div>', {
        html: '<h5>' + val2.kTitel + '</h5>',
        class: 'itemBody',
      }).appendTo(cItem);

      let itemFooter = $('<div>', {
        class: 'itemFooter ',
        'data-kid': val2.kId,
      }).appendTo(cItem);

      $('<div>', {
        class: 'duration',
        html:
          '<div>E-læring: ' +
          minToHoursMin(val2.eTid) +
          '</div><div>Fremmøde: ' +
          minToHoursMin(val2.fTid) +
          '</div>',
      }).appendTo(itemFooter);

      $('<div>', {
        class: 'viewCourse icon click',
        'data-task': 'view',
        title: 'Se e-kurset',
      }).appendTo(itemFooter);

      $('<div>', {
        class: 'detail icon click',
        'data-task': 'detail',
        title: 'Yderlige detaljer',
      }).appendTo(itemFooter);

      $('<div>', {
        class: 'info icon hover',
      }).appendTo(itemFooter);
    });
    $('.kategoriContainer')
      .on('click', '.icon.click', function() {
        console.log('click');
        let kId = $(this)
          .parent()
          .attr('data-kId');
        let task = $(this).attr('data-task');
        onIconClick(kId, task);
        // console.log('kId:', kId);
      })
      .on('mouseover', '.icon.hover', function() {
        let kId = $(this)
          .parent()
          .attr('data-kId');
        // console.log('IN kId:', kId);
        showHideInfo(kId, true);
      })
      .on('mouseout', '.icon.hover', function() {
        let kId = $(this)
          .parent()
          .attr('data-kId');
        // console.log('OUT kId:', kId);
        showHideInfo(kId, false);
      });
    $('.slider')
      .slick({
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        dots: false,
        infinite: false,
        // speed: 300,
        // slidesToShow: 3,
        // slidesToScroll: 1,
        // adaptiveHeight:true,
        responsive: [
          {
            breakpoint: 4000,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      })
      .on('afterChange', function(event, slick, currentSlide) {
        // console.log('event', event);
        // console.log('event.currentTarget.id:', event.target.id);
        // console.log('slick.instanceUid:', slick.instanceUid);
        // console.log('currentSlide:', currentSlide);
        saveScrollPos(event.currentTarget.id, currentSlide);
        // left
      });
    $('#testBtn').click(function() {});
    if (Model.tempUserData.scrollPos) {
      $.each(Model.tempUserData.scrollPos, function(key, val) {
        // console.log('key:' + key + ' val:' + JSON.stringify(val, null, '\t'));
        if (key === 'window') {
          window.scrollTo(0, val);
        } else {
          $('#' + key).slick('slickGoTo', val, true);
        }
      });
    }
    window.addEventListener('scroll', function() {
      saveScrollPos('window', window.scrollY);
    });
  } else {
    displayWrongUrlMsg();
  }
};

let displayWrongUrlMsg = function() {
  // console.log('Model:', Model);
  $('.loading').removeClass('loading');
  // $('body.loading').removeClass('loading');
  $('<div>', {
    id: 'wrongUrlMsg',
    html: 'Beklager, siden kan ikke vises',
  }).appendTo($('#coursesContainer'));
};
let showHideInfo = function(kId, show) {
  // console.log('%ckId:' + kId, 'color:orange;');
  if (show) {
    let beskrivelse = Model.data[kId].maalgruppe_beskrivelse;
    let parentContainer = $('#coursesContainer');
    let parentContRect = parentContainer.offset();
    let parentContWidth = parentContainer.outerWidth();
    let parentContRightPos = parentContRect.left + parentContWidth;
    let parentObj = $('#cItem_' + kId + ' .icon.hover');
    let parentObjWidth = parentObj.outerWidth();
    let parentObjHeight = parentObj.outerHeight();
    let rect = parentObj.offset();

    let courseInfoPopup = $('<div>', {
      id: 'courseInfoPopup',
      class: 'arrow_box',
      html:
        ' <div class="pHeader">Kurset er baseret på følgende kernekompentcer</div><div class="pBody">' +
        beskrivelse +
        '</div>',
    }).appendTo(parentContainer);
    let popUpWidth = courseInfoPopup.outerWidth();
    let popUpHeight = courseInfoPopup.outerHeight();
    let css = {
      top: rect.top - 0.5 * popUpHeight + 0.5 * parentObjHeight,
      left: 0,
    };
    let leftRightClass;
    if (rect.left + popUpWidth + 10 >= parentContRightPos) {
      css.left = rect.left - popUpWidth - 10;
      leftRightClass = 'right';
    } else {
      css.left = rect.left + parentObjWidth + 10;
      leftRightClass = 'left';
    }

    courseInfoPopup.addClass(leftRightClass);
    courseInfoPopup.css(css);
  } else {
    $('#courseInfoPopup').remove();
  }
};
let onIconClick = function(kId, task) {
  // console.log('function: "onIconClick()" called: kId:', kId, task);
  switch (task) {
    case 'detail':
      ModalWindow.openDetailModal(kId);
      break;
    case 'view':
      console.log('%cview:', 'color:orange;');

      window.open(
        Model.urls.player + '?p=' + Model.parameters.projektId + '&t=e&k=' + kId
      );

      break;
    default:
    //code block
  }
};
let saveScrollPos = function(targetId, slideIndex) {
  // console.log('function: "saveScrollPos()" called');
  // console.log('targetId:', targetId);
  // console.log('slideIndex:', slideIndex);
  let sessionObject = {};
  if (sessionStorage.scrollPos) {
    sessionObject = JSON.parse(sessionStorage.scrollPos);
  }
  //
  // console.log(
  //   'sessionObject before:',
  //   JSON.stringify(sessionObject, null, '\t')
  // );
  sessionObject[targetId] = slideIndex;
  // console.log(
  //   'sessionObject after:',
  //   JSON.stringify(sessionObject, null, '\t')
  // );
  sessionStorage.scrollPos = JSON.stringify(sessionObject);
};
export { RenderPageData, displayWrongUrlMsg };
